module.exports = __webpack_public_path__ + "static/media/Ornate3_After.b32ce801.jpg";